import { UNDO } from 'mk/autogenerated/translations/UndoToast.73da0fe24ae608e0e89cc955adede065'
import Toast from 'mk2/components/toasts/Toast';
import { undoToastUndo } from 'mk2/containers/UndoToast/UndoToast.actions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import React from 'react';
import { connect } from 'react-redux';
import styles from './UndoToast.mscss';

interface OwnProps {
    message: string;
    undoId: string;

    remove();
}

interface StateProps {}

interface DispatchProps {
    onUndo(undoId: string);
}

type Props = OwnProps & StateProps & DispatchProps;

class UndoToast extends React.Component<Props> {

    public render() {
        const { message, remove } = this.props;

        return (
            <Toast
                className={styles.UndoToast}
                type="success"
                remove={remove}
            >
                {message}
                {' '}
                <a
                    href="#"
                    className={styles.UndoToast__undo}
                    onClick={this.onUndo}
                >
                    {UNDO}
                </a>
            </Toast>
        );
    }

    private onUndo = (event: React.MouseEvent<HTMLAnchorElement>) => {
        const { onUndo, undoId, remove } = this.props;
        event.preventDefault();
        onUndo(undoId);
        remove();
    };
}

function mapStateToProps(state: AppState): StateProps {
    return {};
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onUndo: undoToastUndo,
};

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(UndoToast);
